
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import authStorage from './utils/authStorage';

ReactDOM.render(<App authData={authStorage.get()} />, document.getElementById('root'));
